/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Print_Admin_Col_TimeInputs */

const vi_print_admin_col_time = /** @type {(inputs: Print_Admin_Col_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tạo lúc`)
};

/**

* @param {Print_Admin_Col_TimeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const print_admin_col_time = /** @type {((inputs?: Print_Admin_Col_TimeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Print_Admin_Col_TimeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_print_admin_col_time(inputs)
});